import React, { Fragment } from "react";
import { Link } from "react-router-dom";
// Redux
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { logout } from "../../reducers/authSlice";
import { withRouter } from "../../utils/withRouter";

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expandedMenus: [], // Tracks the IDs of all currently expanded menus
    };
    // Create a ref for the sidebar DOM element
    this.sidebarRef = React.createRef();
  }

  componentDidMount() {
    // Attach the event listener to handle clicks outside the sidebar
    document.addEventListener("mousedown", this.handleOutsideClick);
  }

  componentWillUnmount() {
    // Detach the event listener when the component is unmounted
    document.removeEventListener("mousedown", this.handleOutsideClick);
  }

  /**
   * Handles clicks outside the sidebar to close it on mobile.
   * This logic assumes that when the sidebar is open on mobile/hamburger view,
   * the <body> element has a class like 'sidebar-offcanvas-open' or similar
   * which is removed to close the sidebar.
   */
 handleOutsideClick = (event) => {
    const sidebarElement = this.sidebarRef.current;

    // 1. Check if the sidebar element exists and is currently open (active)
    if (sidebarElement && sidebarElement.classList.contains("active")) {
      // 2. Check if the click is outside the sidebar element
      if (!sidebarElement.contains(event.target)) {
        
        // 3. Find the navbar toggle button (if it exists) to prevent closing if the toggle is clicked
        const navbarToggle = document.querySelector('[data-toggle="offcanvas"]'); // Common attribute for the toggle
        
        if (!navbarToggle || !navbarToggle.contains(event.target)) {
          // **ACTION TO CLOSE THE SIDEBAR**
          // Remove the 'active' class from the sidebar element to close it.
          sidebarElement.classList.remove("active"); 
        }
      }
    }
  };

  _logout = async () => {
    await this.props.logout();
    this.props.navigate("/admin/login");
  };

  handleParentClick = (id) => {
    this.setState((prevState) => {
      const expandedMenus = [...prevState.expandedMenus];
      const index = expandedMenus.indexOf(id);

      if (index > -1) {
        // If menu is already expanded, remove it
        expandedMenus.splice(index, 1);
      } else {
        // If menu is not expanded, add it
        expandedMenus.push(id);
      }

      return { expandedMenus };
    });
  };

 navbar = [
    {
      name: "Dashboard",
      id: "dashboard",
      icon: "icon-chart menu-icon",
      link: "/admin/dashboard",
      level: 1,
      children: [],
    },

    {
      name: "Users",
      id: "users",
      icon: "icon-user-following menu-icon",
      link: null,
      level: 1,
      children: [
        {
          name: "All Users",
          id: "all-user",
          icon: null,
          link: "/admin/users",
          children: [],
          level: 2,
        },
        {
          name: "Add User",
          id: "add-user",
          icon: null,
          link: "/admin/add-users",
          children: [],
          level: 2,
        },
        {
          name: "Manage User",
          id: "manage-user",
          icon: null,
          link: "/admin/manage-users",
          children: [],
          level: 2,
        },
      ],
    },
    {
      name: "Products",
      id: "products",
      icon: "icon-basket menu-icon",
      link: null,
      level: 1,
      children: [
        {
          name: "View Products",
          id: "view-products",
          icon: null,
          level: 2,
          link: "/admin/products",
          children: [],
        },
        {
          name: "Attributes",
          id: "Attributes",
          icon: null,
          level: 2,
          link: "/admin/attributes",
          children: [],
        },
        {
          name: "Attribute Groups",
          id: "Attributes",
          icon: null,
          level: 2,
          link: "/admin/attribute-groups",
          children: [],
        },
        {
          name: "Bulk Products",
          id: "bulk-products",
          icon: null,
          level: 2,
          link: "/admin/bulk-products",
          children: [],
        },
        {
          name: "Bulk Inventory",
          id: "bulk-inventory",
          icon: null,
          level: 2,
          link: "/admin/bulk-inventory",
          children: [],
        },

        {
          name: "Update Model Number",
          id: "update-productId",
          icon: null,
          level: 2,
          link: "/admin/update-model-number",
          children: [],
        },

        {
          name: "Add Product Cost",
          id: "add-bulk-products",
          icon: null,
          level: 2,
          link: "/admin/add-product-cost/",
          children: [],
        },
        {
          name: "Download SKU",
          id: "sku",
          icon: null,
          level: 2,
          link: "/admin/downloads/sku",
          children: [],
        },
        // {
        //   name: "Create Coupons",
        //   id: "create-coupons",
        //   icon: null,
        //   level: 2,
        //   link: "/admin/create-coupon",
        //   children: [],
        // },
        {
          name: "Coupons",
          id: "_Coupons",
          icon: null,
          level: 2,
          link: "/admin/coupons",
          children: [],
        },
        {
          name: "Dynamic Pricing",
          id: "dynamic pricing",
          icon: null,
          level: 2,
          link: "/admin/dynamic-pricing",
          children: [],
        },
        {
          name: "Discount Code",
          id: "discount-code",
          level: 2,
          icon: "null",
          link: "/admin/discount-code",
          children: [],
        },
      ],
    },
    {
      name: "Categories",
      id: "Categories",
      icon: "icon-tag menu-icon",
      link: null,
      level: 1,
      children: [
        {
          name: "Main Category",
          id: "main-category",
          icon: null,
          link: null,
          level: 3,
          children: [
            {
              name: "Insert Main Category",
              id: "insert-main-category",
              icon: null,
              link: "/admin/create-main-category",
              children: [],
              level: 4,
              showArrow: false,
            },
            {
              name: "View Main Category",
              id: "view-main-category",
              icon: null,
              link: "/admin/main-categories",
              children: [],
              level: 4,
              showArrow: false,
            },
          ],
        },
        {
          name: "Child Category",
          id: "child-category",
          icon: null,
          link: null,
          level: 3,
          children: [
            {
              name: "Insert Child Category",
              id: "insert-child-category",
              icon: null,
              link: "/admin/create-child-category",
              children: [],
              level: 4,
              showArrow: false,
            },
            {
              name: "View Child Categories",
              id: "view-child-category",
              icon: null,
              link: "/admin/child-categories",
              children: [],
              level: 4,
              showArrow: false,
            },
          ],
        },
        {
          name: "Sub Categories",
          id: "sub-category",
          icon: null,
          level: 3,
          link: null,
          children: [
            {
              name: "Insert Sub Category",
              id: "insert-sub-category",
              icon: null,
              link: "/admin/create-sub-category",
              children: [],
              level: 4,
              showArrow: false,
            },
            {
              name: "View Sub Categories",
              id: "view-sub-category",
              icon: null,
              link: "/admin/sub-categories",
              children: [],
              level: 4,
              showArrow: false,
            },
          ],
        },
        {
          name: "Child Sub Categories",
          id: "child-sub-category",
          icon: null,
          level: 3,
          link: null,
          children: [
            {
              name: "Insert Child Sub Category",
              id: "insert-child-sub-category",
              icon: null,
              link: "/admin/create-child-subcategory",
              children: [],
              showArrow: false,
            },
            {
              name: "View Child Sub Categories",
              id: "view-child-sub-category",
              icon: null,
              link: "/admin/child-subcategories",
              children: [],
              showArrow: false,
            },
          ],
        },
      ],
    },
    {
      name: "Orders",
      id: "orders",
      level: 1,
      icon: "icon-grid menu-icon",
      link: null,
      children: [
        {
          name: "Sale Analysis",
          id: "sale-analysis",
          level: 1,
          icon: null,
          link: "/admin/sale-analysis",
          children: [],
        },
        {
          name: "Pending Orders",
          id: "pending-orders",
          icon: null,
          level: 2,
          link: "/admin/pending-orders",
          children: [],
        },
        {
          name: "Process Orders",
          id: "process-orders",
          icon: null,
          level: 2,
          link: "/admin/process-orders",
          children: [],
        },
        {
          name: "Quote Orders",
          id: "quote-orders",
          icon: null,
          level: 2,
          link: "/admin/quote-orders",
          children: [],
        },
      ],
    },

    {
      name: "Reviews",
      id: "reviews",
      level: 1,
      icon: "icon-envelope-letter menu-icon",
      link: null,
      children: [
        {
          name: "Manage Reviews",
          id: "manage-reviews",
          icon: null,
          level: 2,
          link: "/admin/manage-reviews",
          children: [],
        },
        {
          name: "Review Summary",
          id: "review-summary",
          icon: null,
          level: 2,
          link: "/admin/review-summary",
          children: [],
        },
      ],
    },

    {
      name: "Blogs",
      id: "blogs",
      level: 1,
      icon: "icon-speech menu-icon",
      link: null,
      children: [
        {
          name: "Create Blog Post",
          id: "create-blog",
          icon: null,
          level: 2,
          link: "/admin/blogs/create-blog",
          children: [],
        },

        {
          name: "Blogs",
          id: "blogs",
          icon: null,
          level: 2,
          link: "/admin/blogs",
          children: [],
        },
      ],
    },

    {
      name: "Mail",
      id: "mail",
      level: 1,
      icon: "icon-envelope-letter menu-icon",
      link: "/admin/bulk-mail",
      children: [],
    },

    {
      name: "Customer Management",
      id: "customer-management",
      icon: "icon-user-following menu-icon",
      link: null,
      level: 1,
      children: [
        {
          name: "CS Dashboard",
          id: "cs-dashboard",
          icon: null,
          level: 2,
          link: "/admin/cs-dashboard",
          children: [],
        },
        {
          name: "All Tickets",
          id: "all-tickets",
          icon: null,
          level: 2,
          link: "/admin/all-tickets",
          children: [],
        },
        // {
        //   name: "Customer Tickets",
        //   id: "customer-service-dashboard",
        //   icon: null,
        //   level: 2,
        //   link: "/admin/customer-service-dashboard",
        //   children: [],
        // },

        {
          name: "Upload Files",
          id: "upload-files",
          icon: null,
          level: 2,
          link: "/admin/upload-file",
          children: [],
        },
      ],
    },
    {
      name: "Vendor Management",
      id: "multivendor-management",
      icon: "icon-people menu-icon",
      link: null,
      level: 1,
      children: [
        {
          name: "Vendors",
          id: "vendors",
          icon: null,
          level: 2,
          link: "/admin/vendors",
          children: [],
        },
        {
          name: "Vendors Inventory",
          id: "vendors-inventory",
          icon: null,
          level: 2,
          link: "/admin/vendors-inventory",
          children: [],
        },
        {
          name: "Create Vendors",
          id: "create-vendors",
          icon: null,
          level: 2,
          link: "/admin/create-vendor",
          children: [],
        },
        {
          name: "Vendor Setting",
          id: "vendor-setting",
          icon: null,
          level: 2,
          link: "/admin/vendor-setting",
          children: [],
        },
        {
          name: "Vendor Coupons",
          id: "vendor-coupons",
          icon: null,
          level: 2,
          link: "/admin/vendor-coupons",
          children: [],
        },
      ],
    },
    {
      name: "SEO Management",
      id: "content-seo",
      level: 1,
      icon: "icon-magnifier menu-icon",
      link: null,
      children: [
        {
          name: "Title & Description",
          id: "title-description",
          icon: null,
          level: 2,
          link: "/admin/title-and-description",
          children: [],
        },
        {
          name: "Keyword List",
          id: "keyword-list",
          icon: null,
          level: 2,
          link: "/admin/keyword-list",
          children: [],
        },
        {
          name: "AI Product Titles",
          id: "ai-product-titles",
          icon: null,
          level: 2,
          link: "/admin/ai-product-titles",
          children: [],
        },
      ],
    },
    {
      name: "FAQs",
      id: "FAQs",
      icon: "icon-chart menu-icon",
      link: "/admin/frequently-asked-questions",
      level: 1,
      children: [],
    },
    {
      name: "Logs",
      id: "error-logs",
      level: 1,
      icon: "icon-shield menu-icon",
      link: null,
      children: [
        {
          name: "Error Logs",
          id: "error-logs",
          icon: null,
          level: 2,
          link: "/admin/error-log",
          children: [],
        },
        {
          name: "ETL Error Logs",
          id: "etl-error-logs",
          icon: null,
          level: 2,
          link: "/admin/etl-error-log",
          children: [],
        },
      ],
    },
    {
      name: "Shipping",
      id: "shipping",
      level: 1,
      icon: "icon-plane menu-icon",
      link: null,
      children: [
        {
          name: "Companies Lists",
          id: "companies-lists",
          icon: null,
          level: 2,
          link: "/admin/shipping/companies-lists",
          children: [],
        },
        {
          name: "Add Company",
          id: "add-company",
          icon: null,
          level: 2,
          link: "/admin/shipping/add-shipping-company",
          children: [],
        },
      ],
    },
    {
      name: "Setting",
      id: "wp-homepage",
      icon: "icon-settings menu-icon",
      link: null,
      level: 1,
      children: [
        {
          name: "Home Page",
          id: "wp-homepage",
          icon: null,
          level: 2,
          link: "/admin/wp-homepage",
          children: [],
        },
        {
          name: "Layouts",
          id: "layouts",
          icon: null,
          level: 2,
          link: "/admin/layouts",
          children: [],
        },
        {
          name: "Mega Menu",
          id: "header",
          icon: null,
          level: 2,
          link: "/admin/header",
          children: [],
        },
        {
          name: "Custom Header",
          id: "custom-header",
          icon: null,
          level: 2,
          link: "/admin/custom-header",
          children: [],
        },
        {
          name: "Category Menu",
          id: "header",
          icon: null,
          level: 2,
          link: "/admin/category-menu",
          children: [],
        },
        {
          name: "Inspiration",
          id: "Inspiration",
          icon: null,
          level: 2,
          link: "/admin/inspiration",
          children: [],
        },
        {
          name: "Inspiration Tags",
          id: "Tags",
          icon: null,
          level: 2,
          link: "/admin/inspiration-tags",
          children: [],
        },
        {
          name: "Filters",
          id: "filters",
          icon: null,
          link: null,
          level: 2,
          children: [
            {
              name: "Filter Category",
              id: "filter-category",
              icon: null,
              level: 3,
              link: "/admin/filter-category",
              children: [],
            },
            // {
            //   name: "Global Filters",
            //   id: "global-filters",
            //   level: 3,
            //   icon: null,

            //   link: "/admin/global-filters",
            //   children: [],
            // },
            {
              name: "Custom Global Filters",
              id: "custom-global-filters",
              level: 3,
              icon: null,
              link: "/admin/custom-global-filters",
              children: [],
            },
          ],
        },
        {
          name: "Pages",
          id: "terms-of-use",
          icon: null,
          level: 2,
          link: null,
          children: [
            {
              name: "View Pages",
              id: "view-terms-of-use",
              icon: null,
              level: 3,
              link: "/admin/terms",
              children: [],
            },
          ],
        },


        {
          name: "Permissions",
          id: "permissions",
          icon: null,
          level: 2,
          link: "/admin/permissions",
          children: [],
        },
      ],
    },
  ];

  getStyles = (level) => {
    return level === 1
      ? "14px"
      : level === 2
      ? "13px"
      : level === 3
      ? "11px"
      : "10px";
  };

  /**
   * Checks if a given route is permitted for the current user.
   * If the user is an admin, all routes are allowed.
   * Otherwise, it checks against the user's permissions array.
   */
  hasPermissionForRoute = (link) => {
    const { user, permissions } = this.props.auth;

    // Admins have access to everything
    if (user?.role === "admin") {
      return true;
    }

    if (!link) return false;

    // Normalize link by removing trailing slash if any
    const normalizedLink = link.endsWith('/') && link !== '/' ? link.slice(0, -1) : link;

    // Check if the link exists in the user's permissions
    const hasPermission = permissions?.some((p) => {
      if (!p.frontendUrl) return false;
      const normalizedProjUrl = p.frontendUrl.replace(/\/:[^/]+/g, '');
      const normalizedProjUrlClean = normalizedProjUrl.endsWith('/') && normalizedProjUrl !== '/' ? normalizedProjUrl.slice(0, -1) : normalizedProjUrl;
      return normalizedLink === normalizedProjUrlClean || normalizedLink.includes(normalizedProjUrlClean) || normalizedProjUrlClean.includes(normalizedLink);
    });
    return hasPermission;
  };

  renderNavbar = (navbar) => {
    const { expandedMenus } = this.state;

    return navbar
      .map((navItem) => {
        // If the item has children, recursively render them
        if (navItem.children && navItem.children.length > 0) {
          const renderedChildren = this.renderNavbar(navItem.children);
          if (renderedChildren.length > 0) {
            return {
              ...navItem,
              renderedChildren,
            };
          }
          return null;
        }

        // If it's a leaf node, check permission
        if (navItem.link && this.hasPermissionForRoute(navItem.link)) {
          return navItem;
        }

        return null;
      })
      .filter((navItem) => navItem !== null)
      .map((navItem, index) => {
        const {
          name,
          id,
          icon,
          link,
          renderedChildren,
          style = {},
          showArrow = true,
          level,
        } = navItem;

        if (renderedChildren && renderedChildren.length > 0) {
          return (
            <Fragment key={index}>
              <li
                key={index}
                className={`nav-item ${
                  navItem?.link === this.props.location.pathname && "active"
                }`}
                style={{ ...style, fontSize: this.getStyles(level) }}
              >
                <a
                  className="nav-link"
                  data-toggle="collapse"
                  href={`#${id}`}
                  aria-expanded={expandedMenus.includes(id)}
                  aria-controls={id}
                  onClick={() => this.handleParentClick(id)}
                  style={{ fontSize: "inherit" }}
                >
                  <span className="menu-title" style={{ fontSize: "inherit" }}>
                    {name}
                  </span>
                  <i className={icon} />
                </a>
                <div
                  className={`collapse ${expandedMenus.includes(id) && "show"}`}
                  id={id}
                >
                  <ul className="nav flex-column sub-menu">
                    {renderedChildren}
                  </ul>
                </div>
              </li>
            </Fragment>
          );
        }

        return (
          <Fragment key={index}>
            <li
              className={`nav-item ${
                this.props.location.pathname === link && "active"
              }`}
              style={{ ...style, fontSize: this.getStyles(level) }}
            >
              <Link
                className={showArrow ? "nav-link" : "nav-item-simplified"}
                to={link}
                style={{ fontSize: "inherit" }}
              >
                <span className="menu-title" style={{ fontSize: "inherit" }}>
                  {name}
                </span>
                <i className={icon} />
              </Link>
            </li>
          </Fragment>
        );
      });
  };

 render() {
    // Check if the sidebar is active (open in hamburger/offcanvas mode)
    const isActive = this.sidebarRef.current?.classList.contains("active");
    // console.log("isactive",isActive,this.sidebarRef)
    // Conditionally apply mt-2 only when the sidebar is active/open in mobile mode.
    // We append the 'active' class to the initial classes to maintain the state.
    const sidebarClasses = `sidebar sidebar-offcanvas ${isActive ? " active" : ""}`;
      
    return (
      <Fragment>
        <nav 
          className={sidebarClasses} 
          id="sidebar"
          ref={this.sidebarRef} // Attach the ref here
        >
          <ul className="nav">
            {this.renderNavbar(this.navbar)}
            <li className="nav-item">
              <a
                className="nav-link"
                href="!#"
                onClick={(e) => {
                  e.preventDefault();
                  this._logout();
                }}
              >
                <span className="menu-title">Logout</span>
                <i className="icon-logout menu-icon" />
              </a>
            </li>
          </ul>
        </nav>
      </Fragment>
    );
  }
}

logout.propTypes = {
  logout: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(logout()),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Sidebar)
);